// extracted by mini-css-extract-plugin
export default {"input-list":"FormImportFile_input-list__EDSxZ","dropZone":"FormImportFile_dropZone__QhoFT","dragOver":"FormImportFile_dragOver__WtWhW","dropText":"FormImportFile_dropText__TuIg4"};